export default __webpack_public_path__ + "static/media/bgchats.f3f576e0.png";